<!--<p-blockUI [blocked]="loading"><i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="position:absolute;top:25%;left:50%"></i></p-blockUI>-->
<!--<p-confirmDialog [key]="'CRUDBasicListConfirmDialog_'+CRUDItemBezeichnungPluralCapitalized" appendTo="body" id="smth"
  [style.z-index]="'1006 !important'" [acceptLabel]="translate.instant('Ja',true)"
  [rejectLabel]="translate.instant('Nein',true)"></p-confirmDialog>-->
<!-- *ngIf="enableConfirm" -->
<ng-container *ngTemplateOutlet="CRUDTemplatePluginTop"></ng-container>
<!--<ng-container *ngIf="false; then CRUDTemplatePluginTop; else CRUDTemplatePluginTop_dummy"></ng-container>-->
<!--ACHTUNG: killTable_(not)InUse ist HIER IN USE !!! - Ausserdem: "kill" -->

<p-table *ngIf="killTable_notInUse != true" #dt id="crudDataTable" [columns]="cols"
    [value]="crudItems" [(selection)]="selectedCrudItem"
    (onRowSelect)="selectCRUDItem($event.data)" dataKey="id" [reorderableColumns]="true"
    (onColReorder)="handleColReorder($event)" [autoLayout]="true" [responsive]="true" csvSeparator=";"
    [exportFilename]="translate.instant(CRUDItemBezeichnungPluralCapitalized,true)" [scrollable]="true"
    [scrollHeight]="scrollHeight" [sortField]="CRUDSortField"
    [virtualRowHeight]="CRUDLazyLoadVirtualRowHeight != null ? CRUDLazyLoadVirtualRowHeight : null"
    [totalRecords]="totalRecords" [lazy]="CRUDLazyLoad" (onLazyLoad)="loadLazy($event)"
    [virtualScroll]="CRUDLazyLoad == true || mode == 'list'"
    [virtualRowHeight]="CRUDLazyLoad == true || mode == 'list' ? 39 : null" [loading]="loadingTable"
    [rows]="CRUDLazyLoad == true ? 25 : null"
    [tableStyleClass]="'CRUDBasicListTable'"><!-- MODI ggü IMKE: [tableStyleClass]="'CRUDBasicListTable'"-->
    <!-- ungefähre Anzahl Zeilen, die auf den Bildschirm passen. primeNG lädt immer die doppelte Anzahl davon vor -->
    <!--   (onSort)="onSort(dt)" (onFilter)="onFilter(dt)"  -->
    <!-- [virtualScroll]="CRUDLazyLoad"    - wir wollen true, aber den Rest, der hinter CRUDLazyLoad hängt nicht, daher fix: true-->
    <ng-template pTemplate="caption">
        <ng-container *ngTemplateOutlet="CRUDTemplatePluginTableCaption"></ng-container>
        <div *ngIf="CRUDTemplatePluginTableCaption==null" class="ui-g">
            <div class="ui-g-12 ui-md-6" style="text-align: left;">

                <button *ngIf="CRUDItemButtonTitleNeu!=null && NeuButton==null" type="button" pButton icon="fa fa-plus"
                    (click)="addCRUDItem()" [label]="translate.instant('Neu',true)" style="width: auto"></button>
                <!-- width: auto - weil: die ListComponent wird teils auch innerhalb eines cardContainers verwendet (Beispiel EingangsrechnungFreigabeCustomizingDetailComponent)-->
                <!--[label]="CRUDItemButtonTitleNeu"-->

                <p-splitButton *ngIf="CRUDItemButtonTitleNeu!=null && buttonItemsNeuButton!=null" icon="fa fa-plus"
                    [label]="translate.instant('Neu',true)" (onClick)="neuSplitButtonClicked(null)"
                    (onDropdownClick)="neuSplitButtonDropDown(null)" [model]="buttonItemsNeuButton" appendTo="body"
                    [style]="{'width': 'auto', 'word-wrap': 'normal'}"
                    [menuStyleClass]="'crudListNeuMenu'"></p-splitButton>
                <!-- [menuStyle]="{'background-color':'yellow !important', 'min-width':'25em !important'}" -->
                <!-- width: auto - weil: die ListComponent wird teils auch innerhalb eines cardContainers verwendet (Beispiel EingangsrechnungFreigabeCustomizingDetailComponent)-->
                <!-- word-wrap: normal - weil: die ListComponent wird teils auch innerhalb eines cardContainers verwendet (Beispiel EingangsrechnungFreigabeCustomizingDetailComponent)-->

                <!--<button type="button" pButton icon="fa fa-filter" (click)="filterClicked(dt)"
          [label]="filterEnabled ? translate.instant('Filter deaktivieren',true) : translate.instant('Filter aktivieren',true)"
          style="margin-left: 5px; width: auto;"></button>-->
                <!--MODI: nach unten verlegt: 
        <p-multiSelect  *ngIf="mode == 'list'" [options]="columnOptions" [(ngModel)]="cols"
          [selectedItemsLabel]="'{0} ' + translate.instant('Spalte(n) ausgewählt',false)"
          [style]="{'minWidth': '200px','margin-left':'5px', 'width':'auto'}"
          [defaultLabel]="translate.instant('Spalten für Anzeige wählen',true)" [maxSelectedLabels]="0"
          (onChange)="handleColumnOptionChange($event)" dataKey="header">
        </p-multiSelect>-->
            </div>
            <!--MODI: keine Kopfzeile-->
            <div *ngIf="mode == 'list'" class="ui-g-12 ui-md-6" style="text-align: right;">
                <p-multiSelect [options]="columnOptions" [(ngModel)]="cols"
                    [selectedItemsLabel]="'{0} ' + translate.instant('Spalte(n) ausgewählt',false)"
                    [style]="{'minWidth': '200px','margin-left':'-5px', 'width':'auto', 'float':'left'}"
                    [defaultLabel]="translate.instant('Spalten für Anzeige wählen',true)" [maxSelectedLabels]="0"
                    (onChange)="handleColumnOptionChange($event)" dataKey="header" optionLabel="header">
                </p-multiSelect>&nbsp;
                <span class="p-input-icon-left">
                    <i class="fa fa-search"></i>
                    <!--MODI-->
                    <p-splitButton
                        *ngIf="app.mapComponent != null && app.mapComponent.benutzer != null && (app.mapComponent.benutzer.istAdmin == true || app.mapComponent.benutzer.disponieren== true)"
                        id="_DLP_auftrList_splitBtn_auswahl" icon="fa fa-bars"
                        [label]="translate.instant('Auswahl',true)" (onClick)="multimark_openDropdownMenu()"
                        [model]="multimark_selectionButtonItems" appendTo="body"
                        [style]="{'width': 'auto', 'word-wrap': 'normal'}"
                        [menuStyleClass]="'crudListNeuMenu'"></p-splitButton>
                    &nbsp;
                    <input #gb class="globalFilter" type="text" pInputText
                        [placeholder]="translate.instant('Suche',true)"
                        (input)="dt.filterGlobal($event.target.value, 'contains')" style="width: auto">
                </span>
                <button type="button" pButton icon="fa fa-download" label="CSV-Export" (click)="exportCSV(dt)"
                    style="margin-left: 5px; width: auto;"></button>
                <button *ngIf="CRUDItemHelpTopic != null" type="button" pButton icon="fa fa-question"
                    [label]="translate.instant('Hilfe',true)" (click)="showHelp()"
                    style="margin-left: 5px; width: auto;"></button>
                <button *ngIf="CRUDItemButtonTitleAktualisieren!=null" type="button" pButton icon="fa fa-redo"
                    [label]="translate.instant(CRUDItemButtonTitleAktualisieren,true)" (click)="refresh(dt, gb)"
                    style="margin-left: 5px; width: auto;"></button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <!--<th *ngFor="let col of columns" pReorderableColumn [pSortableColumn]="col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>-->
            <!--<th class="CRUD_HideSplitColumn"></th>--><!--MODI: style="width: 10em;" entfernt!-->
            <ng-container *ngFor="let col of columns">
                <th pReorderableColumn [pSortableColumn]="col.field" [class]="col.thStyleClass">
                    {{col.header}}
                    <p-sortIcon *ngIf="CRUDLazyLoadServer!=true" [field]="col.field"></p-sortIcon>

                    <!--<p-columnFilter *ngIf="_app != null && _app.leistungen != null && _app.leistungen.length > 0" [appendTo]="'body'" field="leistung" matchMode="in" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-multiSelect [ngModel]="leistung" [options]="_app.leistungen" placeholder="Alle" (onChange)="filter($event)" optionLabel="bezeichnung" optionValue="leistung">
                  <ng-template let-option pTemplate="item">
                      <div class="__p-multiselect-representative-option">
                          <span class="___ml-1">{{option.bezeichnung}}</span>
                      </div>
                  </ng-template>
              </p-multiSelect>
          </ng-template>
        </p-columnFilter>
        <button pButton (click)="debug(form)" icon="fa-bug" title="dbg"></button>-->
                </th>
            </ng-container>
            <th class="CRUD_HideSplitColumn" *ngIf="CRUDHideMehrButton != true"></th>
            <!--MODI: style="width: 10em;" entfernt!-->
        </tr>

        <tr *ngIf="filterEnabled && CRUDTemplatePluginTableHeader==null">
            <ng-container *ngFor="let col of columns">
                <!--<th *ngFor="let col of columns" [ngSwitch]="true">-->
                <th [ngSwitch]="true" [class]="col.thStyleClass">
                    <!--<p-calendar #filterModified [locale]="DE" (onInput)="getCalendarInputString($event)" (onBlur)="handleCalendarBlur(dt,col.field,col.filterMatchMode,filterModified)"
          appendTo="body" *ngSwitchCase="col.field === 'modified'" dateFormat="dd.mm.yy"></p-calendar>
          <p-calendar #filterCreated [locale]="DE" (onInput)="getCalendarInputString($event)" (onBlur)="handleCalendarBlur(dt,col.field,col.filterMatchMode,filterCreated)"
          appendTo="body" *ngSwitchCase="col.field === 'created'" dateFormat="dd.mm.yy"></p-calendar>-->

                    <!-- MODI: Range/Between Calendar-->
                    <!-- 'filterDynamicCalendar', habe ich so genannt, weil #filterDynamic_{{col.field}} ist nicht nutzbar, trotzdem funktioniert das, siehe: https://stackoverflow.com/questions/48347854/how-to-set-unique-template-reference-variables-inside-an-ngfor-angular -->
                    <!-- Wichtig: onBlur() alleine reicht nicht, denn wenn man im Calendar auf "Monat zurück" - klickt feuert dann schon der Blur! - daher brauchen wir danach per OnSelect() denselben event. -->
                    <!--<p-calendar #filterDynamicCalendar (onInput)="getCalendarInputString($event)" [showWeek]="true"
            (onBlur)="handleCalendarBlur(dt,col.field,col.filterMatchMode,filterDynamicCalendar)"
            (onSelect)="handleCalendarBlur(dt,col.field,col.filterMatchMode,filterDynamicCalendar)" appendTo="body"
            dateFormat="dd.mm.yy" [locale]="DE"
            *ngSwitchCase="crudItemService.propertyTypes!=null && crudItemService.propertyTypeOf!=null && crudItemService.propertyTypeOf(col.field)!=null && crudItemService.propertyTypeOf(col.field).type=='DateTime' || (col.field === 'modified') || (col.field === 'created')">
          </p-calendar>-->
                    <p-calendar #filterDynamicCalendar selectionMode="range" [readonlyInput]="true" [showWeek]="true"
                        appendTo="body" dateFormat="dd.mm.yy" [locale]="DE"
                        *ngSwitchCase="crudItemService.propertyTypes!=null && crudItemService.propertyTypeOf!=null && crudItemService.propertyTypeOf(col.field)!=null && crudItemService.propertyTypeOf(col.field).type=='DateTime' || crudItemService.propertyTypeOf(col.field).type=='DateTimeOffset' || (col.field === 'modified') || (col.field === 'created')"
                        (onShow)="filterCalendarRangeShow(filterDynamicCalendar)"
                        (onClose)="filterCalendarRangeClose(dt,col.field,col.filterMatchMode,filterDynamicCalendar)">
                        <ng-template pTemplate="footer">
                            <button pButton type="button" label="OK"
                                (click)="filterCalendarRange(dt,col.field,col.filterMatchMode,filterDynamicCalendar)"
                                class="p-button-text"></button>
                            <button pButton style="float: right;" type="button" label="Löschen"
                                (click)="filterCalendarRangeClear(dt,col.field,col.filterMatchMode,filterDynamicCalendar)"
                                class="p-button-text"></button>
                        </ng-template>
                    </p-calendar>

                    <!-- width: 100% ist wichtig, damit die checkbox linksbündig steht -->
                    <p-triStateCheckbox #filterDynamicCheckbox
                        *ngSwitchCase="crudItemService.propertyTypes!=null && crudItemService.propertyTypeOf!=null && crudItemService.propertyTypeOf(col.field)!=null && crudItemService.propertyTypeOf(col.field).type=='bool'"
                        [style]="{width: '100%'}"
                        (onChange)="filterCheckBoxChanged(dt,col.field,col.filterMatchMode,filterDynamicCheckbox)">
                    </p-triStateCheckbox>

                    <p-multiSelect [__style]="{'width': '--webkit-fill-available'}"
                        class="CRUDBasicListHeaderFilterMulitSelect" appendTo="body" [(ngModel)]="col.selectFromInit"
                        [defaultLabel]="translate.instant('alle',true)" [options]="col.selectFromValues"
                        optionLabel="label"
                        (onChange)="filterMultiSelectChanged(dt,col.field,col.filterMatchMode,$event)"
                        *ngSwitchCase="col.selectFromValues != null"></p-multiSelect>

                    <input [id]="'filter_' + col.field" *ngSwitchDefault pInputText type="text"
                        (input)="datatable_filter($event.target.value, col.field, col.filterMatchMode)">
                </th>
            </ng-container>
            <th class="CRUD_HideSplitColumn" *ngIf="CRUDHideMehrButton != true"></th>
        </tr>

    </ng-template>
    <ng-template pTemplate="body" let-CRUDItem let-columns="columns" let-rowIndex="rowIndex"><!--MODI-->
        <!--MODI: selectCRUDItem() greift hier nicht, daher: clickTR()-->
        <tr #tr [pSelectableRow]="CRUDItem" (click)="clickTR(CRUDItem)" style="height:39px"><!--MODI: Nötig wegen virtualScroll-->
            <ng-container *ngFor="let col of columns">
                <!--<td *ngFor="let col of columns" [ngSwitch]="true">-->
                <td [ngSwitch]="true" [class]="col.tdStyleClass">
                    <!--MODI:style.width [style.width]="(100 / cols.length)+'%'"-->
                    <div [style.height]="CRUDLazyLoadVirtualRowHeight != null ? (CRUDLazyLoadVirtualRowHeight-17)+'px' : null"
                        [style.overflow]="CRUDLazyLoadVirtualRowHeight != null ? 'hidden' : null">
                        <!-- bei lazyLoading / virtualScroll muss die TR eine fixe Grösse haben, sonst Scrolling ungenau - wird dynmisch gesetzt -->
                        <!-- warum CRUDLazyLoadVirtualRowHeight-17 ?: Provisorium: eine TR ist 117 px hoch -->

                        <span *ngSwitchCase="col.field === 'modified' || col.field === 'created'">{{CRUDItem[col.field]
                            | crudBasic:'':propertyTypeModifiedAndCreated }}</span>
                        <span
                            *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==null">
                            <crud-basic-checkbox [disabled]="true"
                                [nullable]="isCRUDItemNullable(splitFieldName(col.field, false))"
                                [ngModel]="null"></crud-basic-checkbox>
                        </span>
                        <span
                            *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==true">
                            <crud-basic-checkbox [disabled]="true"
                                [nullable]="isCRUDItemNullable(splitFieldName(col.field, false))"
                                [ngModel]="true"></crud-basic-checkbox>
                        </span>
                        <span
                            *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==false">
                            <crud-basic-checkbox [disabled]="true"
                                [nullable]="isCRUDItemNullable(splitFieldName(col.field, false))"
                                [ngModel]="false"></crud-basic-checkbox>
                        </span>
                        <!--
        <span *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==null">
          <p-triStateCheckbox disabled [ngModel]="null"></p-triStateCheckbox>
        </span>
        <span *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==true">
          <p-triStateCheckbox disabled [ngModel]="true"></p-triStateCheckbox>
        </span>
        <span *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==false">
          <p-triStateCheckbox disabled [ngModel]="false"></p-triStateCheckbox>
        </span>
      -->
                        <!--
        <span *ngSwitchCase="typeOf(CRUDItem[splitFieldName(col.field, false)])=='boolean' && CRUDItem[splitFieldName(col.field, false)]==true">
          <p-triStateCheckbox disabled [ngModel]="true"></p-triStateCheckbox>
        </span>
        <span *ngSwitchCase="typeOf(CRUDItem[splitFieldName(col.field, false)])=='boolean' && CRUDItem[splitFieldName(col.field, false)]==false">
          <p-triStateCheckbox disabled [ngModel]="false"></p-triStateCheckbox>
        </span>
      -->

                        <!--MODI: -->
                        <!--<span *ngSwitchCase="col.field === 'behaelterId' || col.field === 'interneBehaelterNummer'"
                            [class]="col.styleClass"
                            pTooltip="{{ CRUDItem[col.field] | behaelter | async }}"
                            tooltipPosition="top">
                            {{ CRUDItem[col.field] | behaelter | async }}
                        </span>-->
                        <!--Variante, die solange die pipe noch lädt ein skeleton anzeigt-->
                        <!--<ng-container *ngSwitchCase="col.field === 'behaelterId' || col.field === '___interneBehaelterNummer'">
                            <ng-container *ngIf="CRUDItem[col.field] | behaelter | async as value; else loading">
                                <span [class]="col.styleClass" pTooltip="{{ value }}" tooltipPosition="top">
                                    {{ value }}
                                </span>
                            </ng-container>
                        
                            <ng-template #loading>
                                <span [class]="col.styleClass">
                                    ...
                                </span>
                            </ng-template>
                        </ng-container>-->

                        <!--Variante, die solange die pipe noch lädt ein skeleton anzeigt-->
                        <ng-container *ngSwitchCase="col.field === 'hersteller'">
                            <ng-container *ngIf="CRUDItem[col.field] | hersteller | async as value; else loading">
                                <span [class]="col.styleClass" pTooltip="{{ value }}" tooltipPosition="top">
                                    {{ value }}
                                </span>
                            </ng-container>
                        
                            <ng-template #loading>
                                <!--<p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>-->
                                <span [class]="col.styleClass">
                                    ...
                                </span>
                            </ng-template>
                        </ng-container>

                        <ng-container *ngSwitchCase="col.field === 'umbauHersteller'">
                            <ng-container *ngIf="CRUDItem[col.field] | hersteller | async as value; else loading">
                                <span [class]="col.styleClass" pTooltip="{{ value }}" tooltipPosition="top">
                                    {{ value }}
                                </span>
                            </ng-container>
                        
                            <ng-template #loading>
                                <!--<p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>-->
                                <span [class]="col.styleClass">
                                    ...
                                </span>
                            </ng-template>
                        </ng-container>

                        <span *ngSwitchCase="col.field === 'behaelterkennzeichen_1'" [class]="col.styleClass"
                            pTooltip="{{ 1 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}" tooltipPosition="top">
                            {{ 1 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}
                        </span>
                        <span *ngSwitchCase="col.field === 'behaelterkennzeichen_2'" [class]="col.styleClass"
                            pTooltip="{{ 2 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}" tooltipPosition="top">
                            {{ 2 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}
                        </span>
                        <span *ngSwitchCase="col.field === 'behaelterkennzeichen_3'" [class]="col.styleClass"
                            pTooltip="{{ 3 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}" tooltipPosition="top">
                            {{ 3 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}
                        </span>
                        <span *ngSwitchCase="col.field === 'behaelterkennzeichen_4'" [class]="col.styleClass"
                            pTooltip="{{ 4 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}" tooltipPosition="top">
                            {{ 4 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}
                        </span>
                        <span *ngSwitchCase="col.field === 'behaelterkennzeichen_5'" [class]="col.styleClass"
                            pTooltip="{{ 5 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}" tooltipPosition="top">
                            {{ 5 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}
                        </span>
                        <span *ngSwitchCase="col.field === 'behaelterkennzeichen_6'" [class]="col.styleClass"
                            pTooltip="{{ 6 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}" tooltipPosition="top">
                            {{ 6 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}
                        </span>
                        <span *ngSwitchCase="col.field === 'behaelterkennzeichen_7'" [class]="col.styleClass"
                            pTooltip="{{ 7 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}" tooltipPosition="top">
                            {{ 7 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}
                        </span>

                        <span *ngSwitchCase="col.field === 'behaelterkennzeichen_8'" [class]="col.styleClass"
                            pTooltip="{{ 8 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}" tooltipPosition="top">
                            {{ 8 | behaelterkennzeichen : CRUDItem.nrVersorgungsunternehmen | async }}
                        </span>


                        <span *ngSwitchCase="col.field === 'verfuegbarkeitsstatus'" [class]="col.styleClass"
                            pTooltip="{{ CRUDItem['verfuegbarkeitsstatus'] | verfuegbarkeitsstatus : CRUDItem.nrVersorgungsunternehmen | async }}" tooltipPosition="top">
                            <ng-container *ngIf="CRUDItem[col.field] | verfuegbarkeitsstatus : CRUDItem.nrVersorgungsunternehmen | async as value; else loading">
                                <span [class]="col.styleClass" pTooltip="{{ value }}" tooltipPosition="top">
                                    {{ value }}
                                </span>
                            </ng-container>
                            
                            <ng-template #loading>
                                <!--<p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>-->
                                <span [class]="col.styleClass">
                                    ...
                                </span>
                            </ng-template>

                            <!--{{ CRUDItem['verfuegbarkeitsstatus'] | verfuegbarkeitsstatus : CRUDItem.nrVersorgungsunternehmen | async }}-->
                        </span>
             
                        <!--<span *ngSwitchCase="col.field === 'baujahr' || col.field === 'umbauBaujahr'">
                            {{ CRUDItem[col.field] | datum: 'monthAndYear' }}
                        </span>-->

                        <!--
              [innerHTML]="transformByCustomPipe(col.field,CRUDItem[splitFieldName(col.field, false)])"
              pTooltip="<i class='fa fa-{{ CRUDItem[col.field] | leistung : 'iconName' }}'></i>&nbsp;{{ CRUDItem[col.field] | leistung : 'plainText' }}"
            -->

                        <!-- HTML Text als innerHTML ausgeben: https://medium.com/@AAlakkad/angular-2-display-html-without-sanitizing-filtering-17499024b079 -->
                        <!-- US 27617 24.08.2022: Erweiterung für Kombination aus customPipe und HTML -->
                        <span
                            *ngSwitchCase="col.field != 'hersteller' && col.field != 'umbauHersteller' && col.field != '___leistung' && (col.customPipe==null || col.customPipe==undefined) && col.spezialContentType!=null && col.spezialContentType=='HTML'"
                            [class]="col.styleClass"
                            [innerHTML]="CRUDItem[splitFieldName(col.field, false)] | keepHtml"></span>

                        <span
                            *ngSwitchCase="col.field != 'hersteller' && col.field != 'umbauHersteller' && col.field != '___leistung' && col.customPipe!=null && col.customPipeAsync!=true && col.spezialContentType!='HTML'"
                            [class]="col.styleClass">{{
                            transformByCustomPipe(col.field,CRUDItem[splitFieldName(col.field, false)]) }}
                        </span>

                        <span
                            *ngSwitchCase="col.field != 'hersteller' && col.field != 'umbauHersteller' && col.field != '___leistung' && col.customPipe!=null && col.spezialContentType!=null && col.spezialContentType=='HTML'"
                            [class]="col.styleClass"
                            [innerHTML]="transformByCustomPipe(col.field,CRUDItem[splitFieldName(col.field, false)])">
                        </span>
                        <!--<span *ngSwitchDefault [class]="col.styleClass">{{CRUDItem[splitFieldName(col.field, false)] | crudBasic:splitFieldName(col.field, true): (crudItemService.typeOf!=null?crudItemService.typeOf(col.field):null) }}   /*3. parm: falls der service typeOf() unterstützt - mitgeben!*/   </span>-->
                        <span *ngSwitchDefault [class]="col.styleClass"
                            [innerHTML]="CRUDItem[splitFieldName(col.field, false)] | crudBasic:splitFieldName(col.field, true): (crudItemService.propertyTypes!=null&&crudItemService.propertyTypeOf!=null?crudItemService.propertyTypeOf(col.field):null)"
                            pTooltip="{{CRUDItem[splitFieldName(col.field, false)] | crudBasic:splitFieldName(col.field, true): (crudItemService.propertyTypes!=null&&crudItemService.propertyTypeOf!=null?crudItemService.propertyTypeOf(col.field):null)}}"></span>

                    </div>
                </td>
            </ng-container>
            <!--MODI: kein splitbutton
      <td class="CRUD_HideSplitColumn" style="width: 10em;">
          <p-splitButton id="splitBtn_{{CRUDItem.id}}" [label]="translate.instant('Mehr',true)" icon="fa fa-bars"
            (onClick)="openDropdownMenu(CRUDItem)" (onDropdownClick)="dropdownClicked(CRUDItem)" [model]="buttonItems"
            appendTo="body" [style]="{'word-wrap': 'normal'}"></p-splitButton>
        </div>
      </td>-->
        </tr>
    </ng-template>
</p-table>
<!--<ng-template #CRUDTemplatePluginTop_dummy>
</ng-template>-->
<button *ngIf="debugMode == true" pButton (click)="debug(form)" icon="fa-bug" title="debug form"></button>



<ng-template #CRUDTemplatePluginTop>
    <!--<p-inputSwitch [(ngModel)]="showList" (ngModelChange)="showList_changed()"></p-inputSwitch>--><!--[(ngModel)]="showList"-->
    <!--<button pButton type="button" label="Liste ausblenden" icon="fa-solid fa-list" iconPos="left" (click)="showList_changed()"></button>-->
    <button pButton *ngIf="mode=='map' && alreadyAusgeblendet == false"
        style="padding: 0.25em; padding-right: 1em;    margin-top: 0.25em; margin-left: 0.375em;" type="button"
        label="Liste ausblenden" iconPos="left" (click)="showList_changed()">
        <span class="fa-stack">
            <i class="fa-solid fa-list fa-stack-1x"></i>
            <i class=" fa-solid fa-slash fa-stack-1x"></i>
        </span>
    </button>
    <button pButton *ngIf="mode=='list' && alreadyAusgeblendet == false"
        style="padding: 0.25em; padding-right: 1em;    margin-top: 0.25em; margin-left: 0.375em;" type="button"
        label="Karte ausblenden" iconPos="left" (click)="showList_changed()">
        <span class="fa-stack">
            <i class="fa-solid fa-list fa-stack-1x"></i>
            <i class=" fa-solid fa-slash fa-stack-1x"></i>
        </span>
    </button>
    <!--<span class="p-input-icon-left">
    <i class="fa fa-search"></i>
  <input #gb class="globalFilter" type="text" pInputText [placeholder]="translate.instant('Suche',true)"
    (input)="dataTable.filterGlobal($event.target.value, 'contains')" style="width: auto">
  </span>
  <button type="button" pButton *ngIf="mode=='list'" icon="fa fa-download" label="CSV-Export" (click)="exportCSV(dataTable)"
  style="margin-left: 5px; width: auto;"></button>-->
</ng-template>